<template lang="pug">
.section-wrapper
  .section-wrapper__container
    transition(name="fade")
      vm-row.heading-preloader(vm-w="12" v-if="isLoadingPreloader")
        vm-col.preloader(vw=12)
          Preloader
    vm-row.heading(vm-justify="space-around", vm-align="center", vm-w=12)
      vm-col(vm-type="flex" vm-align="center" vm-sm=12 vm-lg=10)
        div
          h2 {{ $t('strings.'+ page.name) }}
      vm-col.card.card__wrapper(vm-sm=12 vm-lg=10)
          vm-col(vm-justify="center" class="gutters mt-3" , vm-align="center", vm-sm=12 vm-lg=12)
            h3 Texto Principal
          vm-col(vm-justify="center" class="gutters mt-3" , vm-align="center", vm-sm=12 vm-lg=12)
            div
              b-form-group
                vm-tabs
                  vm-tab(:vm-label="'Español'")
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      ckeditor(v-model="newRecord.data.main_title.es" :editor="editor" :config="editorConfig")
                  vm-tab(:vm-label="'Ingles'")
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      ckeditor(v-model="newRecord.data.main_title.en" :editor="editor" :config="editorConfig")
          vm-col(vm-type="flex" vm-align="center" vm-sm=12 vm-lg=12 vm-justify="flex-end")
            b-form-group
              vm-button(@click="updateRse(newRecord)") Guardar
          vm-col(vm-justify="center" class="gutters mt-3" , vm-align="center", vm-sm=12 vm-lg=12)
            v-reports-rse
</template>

<script>
import Preloader from '@/components/aditionals/Preloader'
import VReportsRse from '@/components/tables/VReportsRse'
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pages')

export default {
  name: 'PageRseDetail',
  components: {
    Preloader,
    ClassicEditor,
    VReportsRse
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    currentPage: 1,
    param: '',
    newRecord: {},
    columns: ['question', 'category_name'],
    isModalAdd: true,
    editor: ClassicEditor,
    editorData: 'Content of the editor.',
    editorConfig: {
      placeholder: 'Descripción de la solución',
      toolbar: [ 'bold', 'italic', '|', 'link', '|' ]
    }
  }),
  computed: {
    ...mapGetters(['page', 'isLoading', 'isLoadingPreloader']),
    enabledDelete () {
      return this.selected.length > 0
    }
  },
  watch: {},
  async created () {
    this.setLoadingPreloader(true)
    if (this.$route.params.id) {
      await this.loadRecord({ id: this.$route.params.id })
      this.newRecord = {
        ...this.page,
        data: JSON.parse(this.page.data)
      }
      console.log(this.newRecord)
    }
    this.setLoadingPreloader(false)
  },
  methods: {
    ...mapActions(['setLoadingPreloader', 'loadRecord', 'updateRse'])
  }
}
</script>

<style lang="scss" scoped>
.mb-3 {
  margin-bottom: 3rem;
}
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.form {
  padding: 20px 10px 0;
}

.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}

.vm-col {
  padding: 0 10px;
}
.vm-table--header {
  padding: 0px !important;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
          display: block;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-idblock;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
.tax-switch {
  display: inline-block;
  input {
    position: relative !important;
  }
}

.con-slot-tabs {
  padding-top: 20px !important;
}
</style>
